import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import Button from '../button';
export default function PickerButton(props) {
  return /*#__PURE__*/React.createElement(Button, _extends({
    size: "small",
    type: "primary"
  }, props));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/date-picker/PickerButton.js
// module id = 800
// module chunks = 0